// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__4i9Jr","details":"styles_details__2DThU","details-row":"styles_details-row__3iCoB"};